import { Box, Flex, Text } from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CTable from "../../../components/Table/table";
import {
  getTelegramActiveUsersRequest,
} from "../../../modules/admin-modules/reports/Actions";
import Layout from "../../../components/dashboard/Layout";
import LogoutMenu from "../../../components/dashboard/Layout/logout-menu";
import { CSVLink } from "react-csv";

const TelegramActiveUsers = () => {
  const dispatch = useDispatch();

  const telegramActiveUsers = useSelector((state) => state.reports.telegramActiveUsers);
  const pagination = useSelector((state) => state.reports.telegramActiveUsersPagination);
  const isLoading = useSelector((state) => state.reports.isLoading);

  const [offset, setPage] = React.useState(0);
  const [size, setPerPage] = React.useState(15);
  const [pageNumber, setPageNumber] = React.useState(0);

  // Reset to first page when per page size changes
  useEffect(() => {
    setPageNumber(0);
  }, [size]);

  // Fetch data when pageNumber or size changes
  useEffect(() => {
    dispatch(getTelegramActiveUsersRequest({ page: pageNumber + 1, per_page: size }));
  }, [dispatch, pageNumber, size]);

  const viewData = (data) => {
    // Handle view data if needed
  };

  const headers = [
    { label: "name", key: "name" },
    { label: "user_name", key: "user_name" },
    { label: "phone", key: "phone" },
    { label: "telegram_username", key: "telegram_username" },
    { label: "group_name", key: "group_name" },
  ];

  const Data = Array.isArray(telegramActiveUsers) 
    ? telegramActiveUsers.map((data, index) => {
        // Calculate index based on current page
        const globalIndex = (pagination.currentPage - 1) * pagination.perPage + index + 1;
        return {
          ...data,
          index: `#${globalIndex}`,
          id: data?.id,
          name: data?.name || data?.student?.name || "N/A",
          user_name: data?.user_name || data?.student?.user_name || "N/A",
          phone: data?.phone || data?.student?.phone || "N/A",
          telegram_username: data?.telegram_username || data?.student?.telegram_username || "N/A",
          group_name: data?.group?.name || data?.student?.group?.name || "N/A",
        };
      })
    : [];

  const columns = [
    {
      Header: "رقم الطالب",
      accessor: "index",
    },
    {
      Header: "اسم الطالب",
      accessor: "name",
    },
    {
      Header: "اسم المستخدم",
      accessor: "user_name",
    },
    {
      Header: "رقم الهاتف",
      accessor: "phone",
    },
    {
      Header: "المجموعة",
      accessor: "group_name",
    },
  ];

  return (
    <Layout>
      <div style={{ minHeight: "400px" }}>
        <Flex
          w="100%"
          my="30px"
          justifyContent="space-between"
          alignItems="center"
          position="relative"
          zIndex="10000000"
          flexWrap="wrap"
        >
          <Text fontSize="24px" fontWeight="600" color="main_1">
            المستخدمون النشطون في التليجرام
          </Text>
          <Flex w={{ base: "100%", md: "30%" }} justifyContent="flex-end" alignItems="center" gap={2}>
            <Box
              mx="10px"
              border="1px solid gray"
              borderRadius="8px"
              padding="10px"
            >
              <CSVLink
                headers={headers}
                data={Data?.length != 0 ? Data : []}
                filename={"telegram-active-users.csv"}
                className="btn btn-primary"
                target="_blank"
              >
                Download
              </CSVLink>
            </Box>
            <LogoutMenu />
          </Flex>
        </Flex>

        <CTable
          selectedData={viewData}
          Columns={columns}
          Data={Data}
          path={"openModel"}
          Actions
          Title={``}
          subTitle=""
          btnTitle=""
          placeHolder=""
          noSearchBar={true}
          noFilter={true}
          footerBtnTitle
          filterList
          addButton
          addButtonTitle=""
          setPage={setPage}
          setPerPage={setPerPage}
          currentpage={pageNumber}
          setPageNumber={setPageNumber}
          noSecondSearchBar={true}
          isLoading={isLoading}
          perPage={size}
          totalPage={pagination.totalPages}
        />
      </div>
    </Layout>
  );
};

export default TelegramActiveUsers;

